<script setup lang="ts">
import CustomSeparator from '@/core/elements/CustomSeparator.vue';

defineProps<{
  separated?: boolean;
}>();

defineSlots<{
  default(): unknown;
  secondary?(): unknown;
}>();
</script>

<template>
  <div class="flex flex-wrap items-center gap-sm">
    <slot />
    <CustomSeparator v-if="separated" class="h-4 shrink-0" direction="vertical" />
    <slot name="secondary" />
  </div>
</template>
